/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class Survey extends Ce {
    constructor() {
        super();
        this.baseUrl += '/survey';
    }

    data({
        surveyName,
        surveySn,
        certCatId,
        certExamType,
        goodsName,
        groupName,
        isAvailable,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            surveyName,
            surveySn,
            certCatId,
            certExamType,
            goodsName,
            groupName,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, surveyName, evaluateTemplateId, surveyScope, businessTableIds, remarks, isAvailable } = {}) {
        return super.post(
            '/save',
            {
                id,
                surveyName,
                evaluateTemplateId,
                surveyScope,
                businessTableIds,
                remarks,
                isAvailable,
            },
            {
                timeout: 0,
                isLoading: true,
            },
        );
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }
}

export default new Survey();
export { Survey };
